<template>
  <v-data-table
    style="background: transparent;"
    :headers="headers"
    :items="ntpParsedArray"
    :footer-props="{ 'items-per-page-options': itemsPerPage }"
    :search="search"
    :loading="loading"
    id="table_ntp"
    mobile-breakpoint=""
  >
    <template
      v-if="ntpParsedArray.length"
      #body="{ items }"
    >
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="index"
        >
          <td>
            <span class="font-weight-medium">{{ item.title.remote }}</span>
          </td>

          <td>
            <span>{{ item.title.tallyCode }}</span>
          </td>

          <td>
            <span>{{ item.title.refid }}</span>
          </td>

          <td>
            <span>{{ item.content.stratum }}</span>
          </td>

          <td>
            <span>{{ item.content.type }}</span>
          </td>
          <td>
            <v-row no-gutters justify="end">
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn icon v-on="on" @click="deleteAddr(item.title.remote)">
                    <v-icon>
                      delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Tooltip</span>
              </v-tooltip>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
    <template v-else>
      <td
        v-if="loading"
      >
        {{ $t('searching') }}
      </td>

      <td
        v-else
      >
        {{ $t('$vuetify.noDataText') }}
      </td>
    </template>
  </v-data-table>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      search: null,
      loading: false,
      headers: [
        {
          text: this.$tc('ip'),
          align: 'start',
          value: 'name'
        },
        {
          text: this.$tc('tallyCode'),
          align: 'left',
          sortable: false,
          value: null
        },
        {
          text: this.$tc('refid'),
          align: 'left',
          sortable: false,
          value: null
        },
        {
          text: this.$tc('stratum'),
          align: 'left',
          sortable: false,
          value: null
        },
        {
          text: this.$tc('type'),
          align: 'left',
          sortable: false,
          value: null
        },
        {
          text: this.$tc('action', 2),
          align: 'right',
          sortable: false,
          value: null
        }
      ],
      itemsPerPage: [10, 20, 50, 100]
    }
  },
  computed: {
    ntpInfo () {
      return this.$store.state.hsm.statInfo.ntp_srv_info
    },
    ntpParsedArray () {
      const ntpRawContent = this.ntpInfo
      const ntpArray = []
      for (const ntpItem of ntpRawContent) {
        const ntpParsedItem = { title: {}, content: {} }
        const pattern = /^(.)([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+) +(\.[A-Z]+\.|[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+) +([0-9]+) (.) +(-|[0-9]+) +([0-9]+) +([0-9]+) +([0-9]+(\.[0-9]+)?) +(-?[0-9]+(\.[0-9]+)?) +([0-9]+(\.[0-9]+)?)$/
        const myMatches = pattern.exec(ntpItem.ntpq_info)
        const tallyCodeParser = function (code) {
          switch (code) {
            case '*': return 'current time source'
            case '#': return 'source selected'
            case 'o': return 'PPS peer'
            case '+': return 'candidate'
            case '-': return 'outlyer'
            case 'x': return 'falseticker'
            case ' ': return 'source discarded'
            default: return 'source discarded'
          }
        }
        const typeParser = function (type) {
          switch (type) {
            case 'l': return 'local'
            case 'u': return 'unicast'
            case 'm': return 'multicast'
            case 'b': return 'broadcast'
            case '-': return 'netaddr'
            default: return 'unicast'
          }
        }
        const decimalToBin = function (val) {
          let num = val
          let binString = ''
          while (num !== 0) {
            binString += num % 2 ? '1' : '0'
            num = Math.floor(num / 2)
          }
          return binString
        }
        const reachParser = function (reach) {
          let fullBinaryString = ''
          for (const character of reach) {
            const charBin = decimalToBin(character)
            fullBinaryString += charBin
          }
          return fullBinaryString.padStart(8, '0')
        }
        if (myMatches) {
          ntpParsedItem.title.tallyCode = tallyCodeParser(myMatches[1])
          ntpParsedItem.title.remote = myMatches[2]
          ntpParsedItem.title.refid = myMatches[3]
          ntpParsedItem.content.stratum = myMatches[4]
          ntpParsedItem.content.type = typeParser(myMatches[5])
          ntpParsedItem.content.when = `${myMatches[6]} s`
          ntpParsedItem.content.pool = `${myMatches[7]} s`
          ntpParsedItem.content.reach = reachParser(myMatches[8])
          ntpParsedItem.content.delay = `${myMatches[9]} ms`
          ntpParsedItem.content.offset = `${myMatches[11]} ms`
          ntpParsedItem.content.jitter = `${myMatches[13]} ms`
        } else {
          // case when its is disabled
          ntpParsedItem.title.remote = ntpItem.addr
        }
        ntpArray.push(ntpParsedItem)
      }

      return ntpArray
    }
  },
  methods: {
    deleteAddr (addr) {
      this.$emit('deleteAddr', { addr })
    }
  }
}
</script>
